// eslint-disable-next-line import/no-cycle
import HTTP from '../http/common';

export default {
  init() {
    return HTTP.get('init');
  },
  profile() {
    return HTTP.get('profile');
  },
  save(data) {
    return HTTP.post('profile/save', data);
  },
  changePassword(data) {
    return HTTP.post('profile/changePassword', data);
  },
  changeStatus(status) {
    return HTTP.get(`changeStatus/${status}`);
  },
  checkStatus() {
    return HTTP.get('ping');
  },
  checkNotifications() {
    return HTTP.get('order/checkNotifications');
  },
  uploadAvatar(data) {
    return HTTP.post('profile/uploadavatar', data);
  },

  telegramCheck() {
    return HTTP.get('profile/checkTelegramAuthorization');
  },

  resetTelegram() {
    return HTTP.get('profile/resetTelegramAuthorization');
  },
};
